import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';
import { CommentingService } from '@scaffold/services/commenting.service';


/**
 * this component extends base and adds a comment list functionality
 */
@Component({
  selector: 'app-comment-list',
  templateUrl: './comment-list.component.html',
  styleUrls: ['./comment-list.component.scss']
})
export class CommentListComponent extends BaseScaffoldComponent implements OnInit {
  commentSubscription;
  showResolved: boolean;
  comments;
  filter;
  constructor(public cdr: ChangeDetectorRef, public renderedService: RenderedService, private commentor: CommentingService) { super(cdr, renderedService) }

  ngOnInit() {
    this.comments = this.item.commentList;

    this.commentSubscription = this.commentor.getCommentsUpdates().subscribe(comments => {
      this.filter = comments.userFilter;
      console.log(comments);
      console.log(this.comments);
      let target_id
      if (this.item.reference !== 'self') {
        target_id = this.info.reference_id
      } else {
        target_id = this.info.id
      }
      if (comments[target_id]) {
        Object.keys(comments[target_id]).forEach(name => {
          let filtered = [];
          comments[target_id][name].forEach(comm => {
            if (!comm.response_to)
              filtered.push(comm);
          });
          let current_list = this.item.commentList.find(i => i.name === name)
          if (current_list)
            current_list.comments = filtered;
        });
        // this.comments = this.filterUser(comments.userFilter);
        console.log(this.comments)
      }
      this.update();
    });
  }
  /** this function filters users in a list of comments
   */

  filterUser(comments) {
    if (this.filter) {
      let visible = [];
      let match = new RegExp(this.filter, 'gi')
      comments.forEach(c => {
        if (c.user && (c.user.first_name.match(match) || c.user.last_name.match(match) || c.user.username.match(match))) {
          visible.push(c.id);
        }else if (c.replies) {
            c.replies.forEach(r => {
              if (r.user && (r.user.first_name.match(match) || r.user.last_name.match(match) || r.user.username.match(match))) {
                visible.push(c.id);
              }
            })
          }
      })
      return comments.filter(c => {
        return visible.includes(c.id);
      });
    } else {
      return comments;
    }
  }
}
